// PWA service-worker registration with auto-update prompt.
import { toast } from 'sonner';

export function registerSW() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Only register on https or localhost (browser requirement)
  const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  if (window.location.protocol !== 'https:' && !isLocalhost) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        // Listen for new SW waiting → toast prompt
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              toast.message('🔄 New version available', {
                description: 'AxialUp ka naya update ready hai. Reload karo to apply karne ke liye.',
                duration: 12000,
                action: {
                  label: 'Reload',
                  onClick: () => {
                    installing.postMessage('SKIP_WAITING');
                    window.location.reload();
                  },
                },
              });
            }
          });
        });

        // Auto-check for updates every 30 min while app is open
        setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);
      })
      .catch(() => {/* ignore SW registration failures */});

    // Reload on controller change (after SKIP_WAITING)
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
